import React from 'react';
import PropTypes from 'prop-types';
import './RadioGroup.styl';

export default class RadioGroup extends React.PureComponent {
  render() {
    const {children, onSelect, value} = this.props;
    if (!children) return null;

    return (
      <div className="radio-group">
        {React.Children.map(children, child =>
          React.cloneElement(child, {
            selectedOption: value,
            onSelect,
          })
        )}
      </div>
    );
  }
}

RadioGroup.propTypes = {
  children: PropTypes.node,
  value: PropTypes.any,
  onSelect: PropTypes.func.isRequired, // option => void
};
